import {DataTableColumn} from "mantine-datatable";
import {BindingDriftReport} from "../types.ts";
import {I18n} from "@aws-amplify/core";
import {RunHealthBadge} from "../profile/Badges.tsx";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";

export const useTableColumns = () => {

    const columns: DataTableColumn<BindingDriftReport>[] = [
        {
            accessor: 'runStartedAt',
            title: I18n.get('Run Started'),
            width: '1fr',
            render: (item: BindingDriftReport) => item.runStartedAt ? formatTimestamp(item.runStartedAt as string) : '-',
        },
        {
            accessor: 'accountsScanned',
            title: I18n.get('Accounts Scanned'),
            width: '1fr',
            render: (item: BindingDriftReport) => item.accountsScanned ?? 0,
        },
        {
            accessor: 'driftDetectedCount',
            title: I18n.get('Drift Detected'),
            width: '1fr',
            render: (item: BindingDriftReport) => item.driftDetectedCount ?? 0,
        },
        {
            accessor: 'repairedCount',
            title: I18n.get('Repaired'),
            width: '1fr',
            render: (item: BindingDriftReport) => item.repairedCount ?? 0,
        },
        {
            accessor: 'repairFailedCount',
            title: I18n.get('Repair Failed'),
            width: '1fr',
            render: (item: BindingDriftReport) => item.repairFailedCount ?? 0,
        },
        {
            accessor: 'repairCappedCount',
            title: I18n.get('Repair Capped'),
            width: '1fr',
            render: (item: BindingDriftReport) => item.repairCappedCount ?? 0,
        },
        {
            accessor: 'status',
            title: I18n.get('Status'),
            width: '1fr',
            render: (item: BindingDriftReport) => <RunHealthBadge record={item}/>,
        },
    ];

    return {
        columns,
    }
}
